export const TIMESTAMP_KEY = '__@t$__';
//# sourceMappingURL=constants.js.map